// extracted by mini-css-extract-plugin
module.exports = {"container":"clinical-portal-3__Modal__container","overlay":"clinical-portal-3__Modal__overlay"};